/**
 * #1106 editor adapter — web.
 *
 * Concrete adapter behind the `TextAreaEditor` interface (see
 * `TextAreaEditor.types.ts`). Today it delegates to `RichTextEditor.web`
 * (Tiptap), the winning candidate from the #1106 evaluation. Swapping the
 * vendor library means changing what this file renders — `TextArea.web.tsx`
 * and everything above it (screens, sanitizers, persistence) is unaffected.
 */
import React from 'react';

import { RichTextEditor } from '../richText/RichTextEditor.web';

import type { TextAreaEditorProps } from './TextAreaEditor.types';

export function TextAreaEditor({
  initialHtml,
  onHtmlChange,
  onResolveImage,
  placeholder,
  inlineImageFieldKey,
  toolbarLayout,
  toolbarSet,
  fillHeight,
  onSubmitShortcut,
  onOpenInlineImage,
  editable = true,
  mentionSuggest,
}: TextAreaEditorProps): React.JSX.Element {
  return (
    <RichTextEditor
      initialHtml={initialHtml}
      onHtmlChange={onHtmlChange}
      onResolveImage={onResolveImage}
      placeholder={placeholder}
      showDiagnostics={false}
      inlineImageFieldKey={inlineImageFieldKey}
      toolbarLayout={toolbarLayout}
      toolbarSet={toolbarSet}
      fillHeight={fillHeight}
      onSubmitShortcut={onSubmitShortcut}
      onOpenInlineImage={onOpenInlineImage}
      editable={editable}
      mentionSuggest={mentionSuggest}
    />
  );
}
